class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    var interviewSwiper = new Swiper(".js-swiper-interview", {
      slidesPerView: 1.4,
      centeredSlides: true,
      loop: true,
      spaceBetween: 16,
      speed: 1000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true
      },
      breakpoints: {
        768: {
          centeredSlides: false,
          slidesPerView: 3,
          spaceBetween: 40,
        }
      },
      pagination: {
        el: ".js-swiper-interview-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".js-swiper-interview-next",
        prevEl: ".js-swiper-interview-prev",
      },
    });

    var loopSwiper = new Swiper(".js-swiper-loop", {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 20,
      speed: 10000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
      },
      breakpoints: {
        768: {
          centeredSlides: false,
          slidesPerView: 3,
          spaceBetween: 20,
        }
      }
    });

    $(window).on('scroll', function() {      
      const scroll = $(window).scrollTop();
      const footerTop = $('.js-footer').offset().top;
      const windowHeight = $(window).height();
      const mvHeight = $('.js-mv').outerHeight();
    
      const fixedEntry = $('.js-fixed-entry');

      if (scroll > mvHeight) {
        fixedEntry.addClass('is-active');
      } else {
        fixedEntry.removeClass('is-active');
      }
      
      if (scroll + windowHeight > footerTop) {
        fixedEntry.removeClass('is-active');
      } else {
        fixedEntry.addClass('is-active');
      }
    });
  }
}
